import axios from 'axios';

import {authHeader} from '../helpers/auth.helper';

export const FETCH_EVENTO = 'FETCH_EVENTO';
export const FETCH_EVENTO_SUCCESS = 'FETCH_EVENTO_SUCCESS';
export const FETCH_EVENTO_FAILURE = 'FETCH_EVENTO_FAILURE';

const ROOT_URL = 'https://api.monitor-backup.suprasys.com.br';
//const ROOT_URL = 'http://168.138.128.21:8891';
//const ROOT_URL = 'http://localhost:8891';

export function fetchEventos(cnpj, start, end) {
    return (dispatch) => {
        dispatch(fetchEventosLoading());

        let config = {
            headers: authHeader()
        };

        let url = `${ROOT_URL}/eventos`;

        if (cnpj && cnpj !== '00000000000000') {
            if (start && end) {
                url += `/${cnpj}/${start}/${end}`;
            }
        } else {
            if (start && end) {
                url += `/${start}/${end}`;
            }
        }

        axios.get(url, config)
            .then(response => dispatch(fetchEventosSuccess(response)))
            .catch(error => dispatch(fetchEventosFailure(error)));
    }
}

export function fetchEventosLoading() {
    return {
        type: FETCH_EVENTO
    }
}

export function fetchEventosSuccess(response) {
    return {
        type: FETCH_EVENTO_SUCCESS,
        payload: response.data
    };
}

export function fetchEventosFailure(error) {
    return {
        type: FETCH_EVENTO_FAILURE,
        payload: error
    }
}



// WEBPACK FOOTER //
// src/actions/evento.js